ConnectStore = require 'components/enhancers/connect_store'
MdaTopicsStore = require 'stores/mda_topics_store'
{ get } = require 'lodash'

storeConnector =
  MdaTopicsStore: (Store) ->
    isFetchingTopics: Store.isFetching()
    topics: Store.getTopics()

# value will be the topic id
TopicSelectorField = ({ isFetchingTopics, topics, onChange, data }) ->
  value = get data, 'options.parentTopicId'
  <div className="topic-selector-field">
    <ul className="standard-list">
      {topics.size is 0 and <li>{$.t 'mda:handouts.no_topics'}</li>}
      {topics.map (topic) ->
        <li className="flex flex-row items-center" key={topic.get('_id')}>
          <label className="flex flex-row items-center">
            <input
              type="radio"
              name="topic"
              value={topic.get('_id')}
              onChange={-> onChange(topic)}
              checked={value is topic.get('_id')}
              disabled={!_.isEmpty(data._id)}
            />
            {topic.get('name')}
          </label>
        </li>
      }
    </ul>
  </div>

module.exports = ConnectStore TopicSelectorField, [
  MdaTopicsStore
], storeConnector
